import type { FC, InputHTMLAttributes } from "react";

import classNames from "classnames";

import styles from "./PrizeLocatorDisplayTypeToggle.module.scss";

export type PrizeLocatorDisplayTypeToggleProps = {
  mapLabel: string;
  listLabel: string;
} & InputHTMLAttributes<HTMLInputElement>;
/**
 * Component used only on tablet and mobile view
 *
 */
export const PrizeLocatorDisplayTypeToggle: FC<PrizeLocatorDisplayTypeToggleProps> = ({
  mapLabel,
  listLabel,
  id,
  ...rest
}) => {
  return (
    <div role="group" className={styles.container}>
      <input {...rest} id={id} type="checkbox" className={styles.switchButtonInput} />
      <label className={styles.mobileViewSwitchButtonLabel} htmlFor={id}>
        <span className={classNames(styles.mobileViewSwitchButton, styles.mobileViewSwitchButtonMap)}>{mapLabel}</span>
        <span className={classNames(styles.mobileViewSwitchButton, styles.mobileViewSwitchButtonList)}>
          {listLabel}
        </span>
      </label>
    </div>
  );
};
